import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import clsx from 'clsx';
import { Section } from '~components/Section';
import { BaseLink } from '~components/BaseLink';
import { Heading } from '~components/Heading';
import { ComponentSharedImageText } from '~components/ComponentSharedImageText';
import * as styles from './CoverageLandingImageText.module.css';

import type { Options } from '@contentful/rich-text-react-renderer';
import type { ContentBlock } from '~components/types';
import type { ContentfulComponentSharedImageText } from '~components/ComponentSharedImageText';

type CoverageLandingImageTextProps = {
  content: ContentfulComponentSharedImageText;
};

const CoverageLandingImageText: ContentBlock<CoverageLandingImageTextProps> = ({
  content,
  ...sectionProps
}): JSX.Element => {
  const options: Options = {
    renderNode: {
      [BLOCKS.HEADING_3]: (_, children) => (
        <Heading level={1} className={styles.heading}>
          {children}
        </Heading>
      ),
      [BLOCKS.PARAGRAPH]: (_, children) => <p className={styles.paragraph}>{children}</p>,
      [BLOCKS.OL_LIST]: (_, children) => <ol className={styles.ol}>{children}</ol>,
      [BLOCKS.UL_LIST]: (_, children) => <ul className={styles.ul}>{children}</ul>,
      [BLOCKS.LIST_ITEM]: (_, children) => <li className={styles.listItem}>{children}</li>,
      [INLINES.HYPERLINK]: (node, children): JSX.Element => <BaseLink href={node.data.uri}>{children}</BaseLink>,
    },
  };

  return (
    <Section {...sectionProps}>
      <ComponentSharedImageText
        className={clsx(styles.wrapper, content.reverseOrder && styles.reverseOrder)}
        imageClassName={styles.image}
        textClassName={styles.text}
        content={content}
        renderProps={options}
        showCtaButton
        enableYouTubePlayer
      />
    </Section>
  );
};

export default CoverageLandingImageText;
